import { useEffect, useState } from 'react';
// import { Table } from 'react-bootstrap';
import { Table } from 'react-bootstrap';
import { useAuth } from '../contexts/AuthContext';

const LogsList = () => {
  const { token } = useAuth();
  const [logs, setLogs] = useState<any[]>([]);
//   const [activeStandard, setActiveStandard] = useState<any | null>(null);
  
  useEffect(() => {
    fetch('/api/logs' , {
      headers: { Authorization: `Bearer ${token}` }
    })
      .then(res => res.json())
      .then(setLogs);
  }, [token]);

  return (
    <>
      {/* <Table striped bordered className='standards-table'> */}
      <Table className='standards-table'>

{/* 
    "id": log.id,
    "timestamp": log.timestamp,
    "message": log.message,
    "type": log.type,
    "user": {
        "id": log.user.id if log.user else None,
        "email": log.user.email if log.user else None
    }
*/}

        <thead>
          <tr className='std_head'>
            <th className='std_number'>ID</th>
            <th className='std_name'>Timestamp</th>
            <th className='std_institution'>Message</th>
            <th className='std_version'>Type</th>
            <th className='std_link'>User ID</th>
            <th className='std_link'>Client ID</th>
          </tr>
        </thead>
        <tbody>
          {logs.map(log_entry => (
            <tr key={log_entry.id} className='std_row'>
              <td className='std_number'>{log_entry.id}</td>
              <td className='std_name'>{log_entry.cre_time}</td>
              <td className='std_institution'>{log_entry.log_text}</td>
              <td className='std_version'>{log_entry.type}</td>
              <td className='std_link'>{log_entry.user_id}</td>
              <td className='std_link'>{log_entry.client_id}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </>
  );
};

export default LogsList;
